import { getBannerRes, getNotificatinRes, supportRespone } from '@/types';
import apiSlice from './apiSlice';

export const contentManagemetApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    //Notification Management
    getNotification: builder.query<getNotificatinRes, { page?: number; limit?: number }>({
      query: ({ page, limit } = {}) => ({
        url: '/notifications/admin',
        method: 'GET',
        params: {
          ...(page ? { page } : {}),
          ...(limit ? { limit } : {}),
          ts: Date.now(),
        },
      }),
      providesTags: ['GetNotification'],
    }),
    addNotification: builder.mutation<
      {},
      {
        type: string;
        title: string;
        body: string;
        isActive: boolean;
        data?: Record<string, any>;
      }
    >({
      query: (body) => ({
        url: '/notifications',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['GetNotification'],
    }),
    //delet notification
    deleteNotification: builder.mutation<any, number>({
      query: (id) => ({
        url: `/notifications/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['GetNotification'],
    }),
    updateNotification: builder.mutation<any, number>({
      query: (id) => ({
        url: `/notifications/${id}/toggle`,
        method: 'PATCH',
      }),
    }),
    //Banner Management
    getBanners: builder.query<getBannerRes, { page?: number; limit?: number }>({
      query: ({ page, limit } = {}) => ({
        url: '/banners/admin',
        method: 'GET',
        params: {
          ...(page ? { page } : {}),
          ...(limit ? { limit } : {}),
          ts: Date.now(),
        },
      }),
      providesTags: ['GetBanner'],
    }),
    //add Banners
    addBanners: builder.mutation<
      {},
      {
        type: string;
        name: string;
        platform: string;
        bannerImage: string;
        // heading: string;
        // description: string;
        size: string;
      }
    >({
      query: (body) => ({
        url: '/banners',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['GetBanner'],
    }),
    //Delet Banner
    deleteBanner: builder.mutation<any, number>({
      query: (id) => ({
        url: `/banners/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['GetBanner'],
    }),
    updateBanner: builder.mutation<any, number>({
      query: (id) => ({
        url: `/banners/${id}`,
        method: 'PATCH',
      }),
    }),

    //ContactSupport Management
    getContactSupport: builder.query<supportRespone, { page?: number; limit?: number }>({
      query: ({ page, limit }) => ({
        url: '/contact-support/admin',
        method: 'GET',
        params: {
          ...(page ? { page } : {}),
          ...(limit ? { limit } : {}),
          ts: Date.now(),
        },
      }),
      providesTags: ['Getsupport'],
    }),
    //add ContactSupport
    addContactSupport: builder.mutation<
      unknown, // API response is unknown
      {
        type: string;
        label: string;
        number: string;
      }
    >({
      query: (body) => ({
        url: '/contact-support',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Getsupport'],
    }),
    //Delet ContactSupport
    deleteContactSupport: builder.mutation<any, number>({
      query: (id) => ({
        url: `/contact-support/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Getsupport'],
    }),
    // update ContactSupport
    updateContactSupport: builder.mutation<any, { id: number; isActive: boolean }>({
      query: ({ id, isActive }) => ({
        url: `/contact-support/active/${id}`,
        method: 'PATCH',
        body: { isActive },
      }),
    }),
  }),
});
export const {
  useAddNotificationMutation,
  useGetNotificationQuery,
  useDeleteNotificationMutation,
  useUpdateNotificationMutation,
  useGetBannersQuery,
  useAddBannersMutation,
  useDeleteBannerMutation,
  useUpdateBannerMutation,
  useGetContactSupportQuery,
  useAddContactSupportMutation,
  useUpdateContactSupportMutation,
  useDeleteContactSupportMutation,
} = contentManagemetApi;
